import { grid, fonts } from ".";
export var subtle = {
  color: "var(--CDS-color-semantic-actions-default)",
  background: "transparent",
  border: "transparent",
  focus: {
    outline: "var(--CDS-color-semantic-actions-default)",
    background: "var(--CDS-color-semantic-actions-surface-active)",
    border: "transparent)",
    color: "var(--CDS-color-semantic-surface-foreground-default)"
  },
  hover: {
    background: "var(--CDS-color-semantic-actions-surface-hover)",
    border: "transparent",
    color: "var(--CDS-color-semantic-surface-foreground-default)"
  },
  active: {
    background: "var(--CDS-color-semantic-actions-surface-active)",
    border: "transparent",
    color: "var(--CDS-color-semantic-surface-foreground-default)"
  },
  disabled: {
    background: "var(--CDS-color-semantic-surface-disabled)",
    border: "transparent",
    color: "var(--CDS-color-semantic-surface-foreground-disabled)"
  }
};
export var defaultState = {
  color: "var(--CDS-color-semantic-actions-default)",
  background: "var(--CDS-color-semantic-actions-surface)",
  border: "transparent",
  focus: {
    outline: "var(--CDS-color-semantic-actions-default)",
    background: "var(--CDS-color-semantic-actions-surface-active)",
    border: "transparent",
    color: "var(--CDS-color-semantic-surface-foreground-default)"
  },
  hover: {
    background: "var(--CDS-color-semantic-actions-surface-hover)",
    border: "transparent",
    color: "var(--CDS-color-semantic-surface-foreground-default)"
  },
  active: {
    background: "var(--CDS-color-semantic-actions-surface-active)",
    border: "transparent",
    color: "var(--CDS-color-semantic-surface-foreground-default)"
  },
  disabled: {
    background: "var(--CDS-color-semantic-surface-disabled)",
    border: "transparent",
    color: "var(--CDS-color-semantic-surface-foreground-disabled)"
  }
};
export var outline = {
  color: "var(--CDS-color-semantic-actions-default)",
  background: "var(--CDS-color-semantic-surface-default)",
  border: "var(--CDS-color-semantic-actions-default)",
  focus: {
    outline: "var(--CDS-color-semantic-actions-default)",
    background: "var(--CDS-color-semantic-actions-surface-active)",
    border: "var(--CDS-color-semantic-actions-surface-active)",
    color: "var(--CDS-color-semantic-surface-foreground-default)"
  },
  hover: {
    background: "var(--CDS-color-semantic-actions-surface-hover)",
    border: "transparent",
    color: "var(--CDS-color-semantic-surface-foreground-default)"
  },
  active: {
    background: "var(--CDS-color-semantic-actions-surface-active)",
    border: "transparent",
    color: "var(--CDS-color-semantic-surface-foreground-default)"
  },
  disabled: {
    background: "var(--CDS-color-semantic-surface-disabled)",
    border: "transparent",
    color: "var(--CDS-color-semantic-surface-foreground-disabled)"
  }
};
export var primary = {
  color: "var(--CDS-color-semantic-surface-foreground-inverted)",
  background: "var(--CDS-color-semantic-actions-default)",
  border: "var(--CDS-color-semantic-actions-default)",
  focus: {
    outline: "var(--CDS-color-semantic-actions-default)",
    background: "var(--CDS-color-semantic-actions-surface-active)",
    border: "transparent",
    color: "var(--CDS-color-semantic-surface-foreground-inverted)"
  },
  hover: {
    color: "var(--CDS-color-semantic-surface-foreground-inverted)",
    background: "var(--CDS-color-semantic-actions-hover)",
    border: "transparent"
  },
  active: {
    color: "var(--CDS-color-semantic-surface-foreground-inverted)",
    background: "var(--CDS-color-semantic-actions-active)",
    border: "transparent"
  },
  disabled: {
    color: "var(--CDS-color-semantic-surface-foreground-disabled)",
    background: "var(--CDS-color-semantic-surface-disabled)",
    border: "transparent"
  }
};
export var critical = {
  color: "var(--CDS-color-semantic-surface-foreground-inverted)",
  background: "var(--CDS-color-semantic-feedback-critical-default)",
  border: "var(--CDS-color-semantic-feedback-critical-default)",
  focus: {
    outline: "var(--CDS-color-semantic-actions-default)",
    background: "var(--CDS-color-semantic-feedback-critical-active)",
    border: "var(--CDS-color-semantic-feedback-critical-active)",
    color: "var(--CDS-color-semantic-surface-foreground-inverted)"
  },
  hover: {
    background: "var(--CDS-color-semantic-feedback-critical-hover)",
    border: "var(--CDS-color-semantic-feedback-critical-hover)",
    color: "var(--CDS-color-semantic-surface-foreground-inverted)"
  },
  active: {
    background: "var(--CDS-color-semantic-feedback-critical-active)",
    border: "var(--CDS-color-semantic-feedback-critical-active)",
    color: "var(--CDS-color-semantic-surface-foreground-inverted)"
  },
  disabled: {
    background: "var(--CDS-color-semantic-surface-disabled)",
    border: "transparent",
    color: "var(--CDS-color-semantic-surface-foreground-disabled)"
  }
};
export var caution = {
  color: "var(--CDS-color-semantic-feedback-warning-foreground)",
  background: "var(--CDS-color-semantic-feedback-warning-default)",
  border: "var(--CDS-color-semantic-feedback-warning-default)",
  focus: {
    outline: "var(--CDS-color-semantic-actions-default)",
    background: "var(--CDS-color-semantic-feedback-warning-active)",
    border: "var(--CDS-color-semantic-feedback-warning-active)",
    color: "var(--CDS-color-semantic-surface-foreground-inverted)"
  },
  hover: {
    background: "var(--CDS-color-semantic-feedback-warning-hover)",
    border: "var(--CDS-color-semantic-feedback-warning-hover)",
    color: "var(--CDS-color-semantic-feedback-warning-foreground)"
  },
  active: {
    background: "var(--CDS-color-semantic-feedback-warning-active)",
    border: "var(--CDS-color-semantic-feedback-warning-active)",
    color: "var(--CDS-color-semantic-surface-foreground-inverted)"
  },
  disabled: {
    background: "var(--CDS-color-semantic-surface-disabled)",
    border: "transparent",
    color: "var(--CDS-color-semantic-surface-foreground-disabled)"
  }
};
export var upgrade = {
  color: "var(--CDS-color-semantic-surface-foreground-inverted)",
  background: "var(--CDS-color-semantic-feedback-positive-default)",
  border: "var(--CDS-color-semantic-feedback-positive-default)",
  focus: {
    outline: "var(--CDS-color-semantic-actions-default)",
    background: "var(--CDS-color-semantic-feedback-positive-active)",
    border: "var(--CDS-color-semantic-feedback-positive-active)",
    color: "var(--CDS-color-semantic-surface-foreground-inverted)"
  },
  hover: {
    background: "var(--CDS-color-semantic-feedback-positive-hover)",
    border: "var(--CDS-color-semantic-feedback-positive-hover)",
    color: "var(--CDS-color-semantic-surface-foreground-inverted)"
  },
  active: {
    background: "var(--CDS-color-semantic-feedback-positive-active)",
    border: "var(--CDS-color-semantic-feedback-positive-active)",
    color: "var(--CDS-color-semantic-surface-foreground-inverted)"
  },
  disabled: {
    background: "var(--CDS-color-semantic-surface-disabled)",
    border: "transparent",
    color: "var(--CDS-color-semantic-surface-foreground-disabled)"
  }
};
export var sizes = {
  small: 32,
  medium: 44,
  large: 48,
  xl: 56
};
export var getButtonPadding = function getButtonPadding(appearance, size, hasIcon) {
  if (appearance === "subtle") {
    switch (size) {
      case "small":
        return {
          paddingTop: 6,
          paddingBottom: 5,
          paddingRight: grid.xsmall,
          paddingLeft: grid.xsmall
        };
      case "medium":
      default:
        return {
          paddingTop: 7,
          paddingBottom: 6,
          paddingRight: grid.small,
          paddingLeft: grid.small
        };
      case "large":
        return {
          paddingTop: 10,
          paddingBottom: 9,
          paddingRight: grid.small,
          paddingLeft: grid.small
        };
    }
  }
  switch (size) {
    case "small":
      return {
        paddingTop: 6,
        paddingBottom: 5,
        paddingRight: hasIcon ? 10 : 12,
        paddingLeft: hasIcon ? 10 : 12
      };
    case "medium":
    default:
      return {
        paddingTop: 10,
        paddingBottom: 9,
        paddingRight: hasIcon ? grid.small : 20,
        paddingLeft: hasIcon ? grid.small : 20
      };
    case "large":
      return {
        paddingTop: 10,
        paddingBottom: 9,
        paddingRight: hasIcon ? grid.small : grid.large,
        paddingLeft: hasIcon ? grid.small : grid.large
      };
  }
};
export var fontStyles = {
  small: fonts["body-2"],
  medium: fonts["body-1"],
  large: fonts["heading-1"]
};